import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import {useMemo} from 'react'
import {getDocumentId} from 'utils'
const useTableAction = (
    itemName,
    tableName,
    itemId,
    tableRowData,
    onClickDelete,
    onClickEdit,
    isExpanded
) => {
    const MoreDetailsIcon = useMemo(
        () => (isExpanded ? ExpandLessRoundedIcon : ExpandMoreRoundedIcon),
        [isExpanded]
    )

    const handleDelete = () => {
        onClickDelete(itemId)
    }

    const handleEdit = () => {
        onClickEdit(getDocumentId(tableRowData))
    }

    return {MoreDetailsIcon, handleDelete, handleEdit}
}

export default useTableAction
